module.exports = "<p>\n  header works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/home/header/header.component.html
// module id = ../../../../../src/app/pos/home/header/header.component.html
// module chunks = main